module.exports = __webpack_public_path__ + "img/index-box3-bg2.2ba5c4d1.png";